// ─── Analytics Data ─────────────────────────────────────────────────────────
export const revenueData = [
  { month: "Jan", revenue: 12400, users: 340, churn: 12 },
  { month: "Feb", revenue: 18200, users: 480, churn: 9 },
  { month: "Mar", revenue: 15800, users: 520, churn: 14 },
  { month: "Apr", revenue: 24100, users: 690, churn: 8 },
  { month: "May", revenue: 28600, users: 820, churn: 6 },
  { month: "Jun", revenue: 32000, users: 950, churn: 11 },
  { month: "Jul", revenue: 29500, users: 1020, churn: 7 },
  { month: "Aug", revenue: 37800, users: 1180, churn: 5 },
  { month: "Sep", revenue: 42100, users: 1340, churn: 9 },
  { month: "Oct", revenue: 39200, users: 1290, churn: 10 },
  { month: "Nov", revenue: 48600, users: 1520, churn: 6 },
  { month: "Dec", revenue: 54000, users: 1780, churn: 4 },
];

export const trafficData = [
  { name: "Organic", value: 44, color: "#6366f1" },
  { name: "Direct", value: 24, color: "#06b6d4" },
  { name: "Referral", value: 18, color: "#8b5cf6" },
  { name: "Social", value: 14, color: "#f59e0b" },
];

export const statsCards = [
  {
    label: "Total Revenue",
    value: "$382,100",
    change: "+18.2%",
    up: true,
    icon: "DollarSign",
  },
  {
    label: "Active Users",
    value: "1,780",
    change: "+12.5%",
    up: true,
    icon: "Users",
  },
  {
    label: "Churn Rate",
    value: "4.2%",
    change: "-2.1%",
    up: false,
    icon: "TrendingDown",
  },
  {
    label: "MRR",
    value: "$54,000",
    change: "+9.8%",
    up: true,
    icon: "Activity",
  },
];

// ─── Users ───────────────────────────────────────────────────────────────────
export const users = [
  {
    id: 1,
    name: "Aria Chen",
    email: "aria@techcorp.io",
    role: "Admin",
    status: "Active",
    plan: "Enterprise",
    joined: "Jan 12, 2024",
    avatar: "AC",
  },
  {
    id: 2,
    name: "Marcus Webb",
    email: "m.webb@design.co",
    role: "Editor",
    status: "Active",
    plan: "Pro",
    joined: "Feb 3, 2024",
    avatar: "MW",
  },
  {
    id: 3,
    name: "Sofia Reyes",
    email: "sofia.r@startup.dev",
    role: "Viewer",
    status: "Inactive",
    plan: "Starter",
    joined: "Feb 18, 2024",
    avatar: "SR",
  },
  {
    id: 4,
    name: "Ethan Park",
    email: "ethan@nexus.ai",
    role: "Admin",
    status: "Active",
    plan: "Pro",
    joined: "Mar 5, 2024",
    avatar: "EP",
  },
  {
    id: 5,
    name: "Luna Patel",
    email: "luna.p@cloud.io",
    role: "Editor",
    status: "Active",
    plan: "Enterprise",
    joined: "Mar 22, 2024",
    avatar: "LP",
  },
  {
    id: 6,
    name: "James Okafor",
    email: "j.okafor@scale.com",
    role: "Viewer",
    status: "Pending",
    plan: "Starter",
    joined: "Apr 9, 2024",
    avatar: "JO",
  },
  {
    id: 7,
    name: "Nadia Volkov",
    email: "nadia@devhub.net",
    role: "Editor",
    status: "Active",
    plan: "Pro",
    joined: "Apr 30, 2024",
    avatar: "NV",
  },
  {
    id: 8,
    name: "Carlos Lima",
    email: "carlos@finwave.io",
    role: "Admin",
    status: "Active",
    plan: "Enterprise",
    joined: "May 14, 2024",
    avatar: "CL",
  },
];

// ─── Pricing ─────────────────────────────────────────────────────────────────
export const pricingPlans = [
  {
    name: "Starter",
    price: 29,
    period: "month",
    description: "Perfect for indie makers and small projects.",
    highlight: false,
    features: [
      "Up to 5 team members",
      "10 GB storage",
      "Basic analytics",
      "Email support",
      "API access (500 calls/day)",
    ],
    cta: "Start Free Trial",
  },
  {
    name: "Pro",
    price: 79,
    period: "month",
    description: "For growing teams that need more power.",
    highlight: true,
    features: [
      "Up to 25 team members",
      "100 GB storage",
      "Advanced analytics",
      "Priority support",
      "API access (10K calls/day)",
      "Custom integrations",
      "Audit logs",
    ],
    cta: "Get Started",
  },
  {
    name: "Enterprise",
    price: 199,
    period: "month",
    description: "Unlimited scale for serious organizations.",
    highlight: false,
    features: [
      "Unlimited team members",
      "1 TB storage",
      "Real-time analytics",
      "Dedicated support & SLA",
      "Unlimited API calls",
      "SSO & SAML",
      "Custom contracts",
      "On-premise option",
    ],
    cta: "Contact Sales",
  },
];

// ─── Testimonials ────────────────────────────────────────────────────────────
export const testimonials = [
  {
    name: "Sarah Mitchell",
    role: "CTO at Versa Labs",
    avatar: "SM",
    quote:
      "NexaFlow cut our deployment time in half. The analytics dashboard is genuinely the best I've used — clean, fast, and actually useful.",
    rating: 5,
  },
  {
    name: "David Osei",
    role: "Founder, BuildFast",
    avatar: "DO",
    quote:
      "We switched from three separate tools to NexaFlow. The unified dashboard and API reliability is unmatched at this price point.",
    rating: 5,
  },
  {
    name: "Priya Nair",
    role: "Product Manager at Orion",
    avatar: "PN",
    quote:
      "Onboarding our 40-person team took less than a day. The role management and audit logs give us the compliance coverage we need.",
    rating: 5,
  },
];

// ─── FAQs ────────────────────────────────────────────────────────────────────
export const faqs = [
  {
    q: "Is there a free trial available?",
    a: "Yes — all plans include a 14-day free trial with no credit card required. You get access to all Pro features during the trial.",
  },
  {
    q: "Can I change plans at any time?",
    a: "Absolutely. You can upgrade or downgrade your plan at any time. Changes take effect immediately and billing is prorated.",
  },
  {
    q: "How secure is my data?",
    a: "We use AES-256 encryption at rest and TLS 1.3 in transit. SOC 2 Type II certified, GDPR and CCPA compliant.",
  },
  {
    q: "What kind of support do you offer?",
    a: "Starter plans get email support with 48h response. Pro plans get priority support with 4h SLA. Enterprise plans get a dedicated account manager.",
  },
  {
    q: "Do you offer custom integrations?",
    a: "Pro and Enterprise plans include access to our full REST API and webhook system. We also have pre-built integrations for Slack, Salesforce, HubSpot, and more.",
  },
  {
    q: "Can I self-host NexaFlow?",
    a: "Enterprise customers can request an on-premise deployment option. Contact our sales team to discuss requirements and licensing.",
  },
];

// ─── Nav Links ───────────────────────────────────────────────────────────────
export const navLinks = [
  { label: "Features", href: "#features" },
  { label: "Pricing", href: "#pricing" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "FAQ", href: "#faq" },
];

export const features = [
  {
    icon: "Zap",
    title: "Lightning Fast",
    description:
      "Sub-100ms response times globally via our edge network. Your users get speed regardless of location.",
    color: "text-yellow-500",
    bg: "bg-yellow-500/10",
  },
  {
    icon: "Shield",
    title: "Enterprise Security",
    description:
      "SOC 2 certified, end-to-end encryption, SSO, and granular role-based access control built in.",
    color: "text-emerald-500",
    bg: "bg-emerald-500/10",
  },
  {
    icon: "BarChart2",
    title: "Deep Analytics",
    description:
      "Real-time dashboards with AI-powered insights. Understand your users, revenue, and growth at a glance.",
    color: "text-primary-500",
    bg: "bg-primary-500/10",
  },
  {
    icon: "Puzzle",
    title: "100+ Integrations",
    description:
      "Connect with Slack, Stripe, Salesforce, HubSpot, and more. Our open API means endless possibilities.",
    color: "text-accent-500",
    bg: "bg-accent-500/10",
  },
  {
    icon: "Users",
    title: "Team Collaboration",
    description:
      "Multi-workspace support, real-time collaboration, and granular permissions for teams of any size.",
    color: "text-violet-500",
    bg: "bg-violet-500/10",
  },
  {
    icon: "Headphones",
    title: "24/7 Support",
    description:
      "World-class support with dedicated account managers for Enterprise. Average response time under 2 hours.",
    color: "text-rose-500",
    bg: "bg-rose-500/10",
  },
];
